import Sortable from "sortablejs";

export function snapshotSetupCustomAttributes(args) {
  const { customAttributes, sortableListId } = args;

  return {
    customAttributes,
    sortableListId,
    init() {
      const form = this.$root.closest("form");

      if (form) {
        const customAttributesEvent = new CustomEvent("dx:input-init", {
          detail: {
            name: "customAttributes",
            values: this.customAttributes.map((customAttribute) => ({
              id: customAttribute.id,
              position: customAttribute.position,
            })),
          },
        });

        form.dispatchEvent(customAttributesEvent);

        this.$watch("customAttributes", () => this.publishValues(form));
      }
    },
    publishValues(form) {
      const customAttributeEvent = new CustomEvent("dx:input-changed", {
        detail: {
          name: "customAttributes",
          values: this.customAttributes.map((customAttribute) => ({
            id: customAttribute.id,
            position: customAttribute.position,
          })),
        },
      });

      form.dispatchEvent(customAttributeEvent);
    },
    setupAttributesSortable() {
      const self = this;
      const sortableAttributeList = document.getElementById(sortableListId);
      new Sortable(sortableAttributeList, {
        animation: 150,
        handle: ".sortable-handle",
        onEnd: function () {
          const newOrder = Array.from(
            sortableAttributeList.querySelectorAll(".sortable-attribute-item"),
          ).map((item, index) => {
            return {
              name: item.innerText,
              id: item?.dataset?.itemId,
              position: index,
            };
          });

          const map = new Map();
          self.customAttributes.forEach((item) =>
            map.set(item?.id.toString(), item),
          );
          const newArray = newOrder.map((item) => ({
            ...map.get(item?.id),
            position: item.position,
          }));

          self.customAttributes = newArray;
        },
      });
    },
  };
}
